export const accordion = {
  colorScheme: {
    light: {
      header: {
        background: '#eef4f7',
        color: '#0e2a4a',
        borderColor: '#e3eaef',
        active: {
          background: '#eef4f7',
          color: '#0e2a4a',
          borderColor: '#e3eaef',
          hover: {
            background: '#eef4f7',
            color: '#0e2a4a',
          },
        },
        hover: {
          background: '#eef4f7',
          color: '#0e2a4a',
        },
      },
      content: {
        background: '#f7fafb',
        color: '#0e2a4a',
        borderColor: '#e3eaef',
      },
    },
    dark: {
      header: {
        background: '#46495aff',
        color: 'white',
        borderColor: '#5B5F69',
        active: {
          background: '#46495aff',
          color: 'white',
          borderColor: '#5B5F69',
          hover: {
            background: '#46495aff',
            color: '{text.color}',
          },
        },
        hover: {
          background: '#46495aff',
          color: '{text.color}',
        },
      },
      content: {
        background: '#393d4d',
        color: 'white',
        borderColor: '#5B5F69',
      },
    },
  },
  css: ({ dt }: { dt: (key: string) => string }) => `
.p-accordionpanel-active {
margin: 0;
}
`,
};
